var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { ToggleButton } from './ToggleButton';
var borderColor = "rgba(255,255,255)";
var textColor = function (isLit, disabledButton) {
    if (disabledButton) {
        return 'rgba(255,255,255,0.5)';
    }
    if (isLit) {
        return 'rgba(0,0,0,1)';
    }
    return 'yellow';
};
var bgColor = function (isLit, disabledButton) {
    if (disabledButton) {
        return 'transparent';
    }
    if (isLit) {
        return 'white';
    }
    return 'transparent';
};
var borderColors = function (isLit, disabledButton) {
    if (disabledButton) {
        return 'rgba(255,255,255,0.5)';
    }
    if (isLit) {
        return borderColor + ";";
    }
    return 'white';
};
var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  font-size: 12px;\n  border: solid 1px\n    ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  text-transform: capitalize;\n  user-select: none;\n  :focus {\n    outline: none;\n  }\n  background: ", ";\n  border-left-width: 1px;\n  border-top-width: 1px;\n  border-right-width: 1px;\n  border-bottom-width: 1px;\n  ", "\n\n  animation-name: ", ";\n  animation-iteration-count: infinite;\n  animation-duration: 2s;\n  :active {\n    border-width: 1px;\n    border-left-width: 1px;\n    border-top-width: 1px;\n\n    border-right-width: 1px;\n    border-bottom-width: 1px;\n    border-width: 2px;\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  font-size: 12px;\n  border: solid 1px\n    ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  text-transform: capitalize;\n  user-select: none;\n  :focus {\n    outline: none;\n  }\n  background: ", ";\n  border-left-width: 1px;\n  border-top-width: 1px;\n  border-right-width: 1px;\n  border-bottom-width: 1px;\n  ",
    "\n\n  animation-name: ", ";\n  animation-iteration-count: infinite;\n  animation-duration: 2s;\n  :active {\n    border-width: 1px;\n    border-left-width: 1px;\n    border-top-width: 1px;\n\n    border-right-width: 1px;\n    border-bottom-width: 1px;\n    border-width: 2px;\n  }\n"])), function (props) { return props.width + "px"; }, function (props) { return props.height + "px"; }, function (props) { return borderColors(props.isLit, props.disabledButton); }, function (props) { return textColor(props.isLit, props.disabledButton); }, function (props) { return bgColor(props.isLit, props.disabledButton); }, function (props) {
    if (props.isToggleButton) {
        return 'padding: 0px;';
    }
    return '';
}, function (props) { return "" + (props.isBlinking ? 'blinkbutton' : ''); });
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 auto;\n  text-align: center;\n"], ["\n  margin: 0 auto;\n  text-align: center;\n"])));
var ToggleButtonContent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var labelTransform = function (label) {
    var lines = label.replace(/\n/g, '<br/>');
    return { __html: lines };
};
export default function TouchPanelButton(props) {
    var label = props.label, onTouchPanelButtonClick = props.onTouchPanelButtonClick, _a = props.bHeight, bHeight = _a === void 0 ? 84 : _a, _b = props.bWidth, bWidth = _b === void 0 ? 84 : _b, id = props.id, _c = props.isToggleButton, isToggleButton = _c === void 0 ? false : _c, content = props.content, onToggleButtonClick = props.onToggleButtonClick, _d = props.disable, disable = _d === void 0 ? false : _d;
    var element = React.createElement("div", null);
    if (label) {
        if (isToggleButton) {
            element = (React.createElement(ToggleButtonContent, null,
                React.createElement(ToggleButton, __assign({ onToggleButtonClick: onToggleButtonClick, content: content, className: "button-internal" }, props))));
        }
        else {
            element = (React.createElement(Content, { className: "button-internal", dangerouslySetInnerHTML: labelTransform(label) }));
        }
    }
    var isDisabled = (content === null || content === void 0 ? void 0 : content.buttonStatus[id]) ? content.buttonStatus[id].isDisabled
        : disable;
    return (React.createElement(Container, __assign({ id: id, height: bHeight, width: bWidth, onClick: function () {
            if (!isDisabled) {
                onTouchPanelButtonClick();
            }
        } }, props, { disabledButton: isDisabled, isLit: (content === null || content === void 0 ? void 0 : content.buttonStatus[id]) && content.buttonStatus[id].isLit, isBlinking: (content === null || content === void 0 ? void 0 : content.buttonStatus[id]) && content.buttonStatus[id].isBlinking, isToggleButton: isToggleButton }), element));
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map